import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/magazines/new/loading';

export const Route = createFileRoute('/_private/settings/magazines/new')({
  component: Loading,
});
